import api from "./api";

const feeStructureService = {
    // GET /api/fee-structures?academicYear=&courseAdmitted=&courseYear=
    getAll: (params = {}) => api.get("/fee-structures", { params }),
    // GET /api/fee-structures/:id
    getById: (id) => api.get(`/fee-structures/${id}`),
    // GET /api/fee-structures/preview/:studentId
    previewForStudent: (studentId) => api.get(`/fee-structures/preview/${studentId}`),
    // POST /api/fee-structures
    create: (data) => api.post("/fee-structures", data),
    // PUT /api/fee-structures/:id
    update: (id, data) => api.put(`/fee-structures/${id}`, data),
    // DELETE /api/fee-structures/:id
    remove: (id) => api.delete(`/fee-structures/${id}`),
};

export default feeStructureService;